import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import CalendarSlot from './CalendarSlot'

const useStyles = makeStyles(theme => ({
  root: {
   
  },
  title: {
    color: '#666',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
}))

const CalendarBlock = ({
  admin,
  data,
  config,
  choosenSlot,
  wrapTitle,
  onClickSlot,
}) => {
  const classes = useStyles()

  return (
    <div className={ classes.root }>
      <div className={ classes.title }>
        { data.name }
      </div>
      <div className={ classes.slots }>
        <List>
          {
            data.slots.map((slot, i) => {
              return (
                <CalendarSlot
                  key={ i }
                  admin={ admin }
                  slot={ slot }
                  config={ config }
                  choosenSlot={ choosenSlot }
                  wrapTitle={ wrapTitle }
                  onClickSlot={ onClickSlot }
                />
              )
            })
          }
        </List>
      </div>
    </div>
  )
}

export default CalendarBlock